import { render, staticRenderFns } from "./ProductsListInfo.vue?vue&type=template&id=5f58d26e"
import script from "./ProductsListInfo.vue?vue&type=script&lang=js"
export * from "./ProductsListInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports